import type { AppSingleSelectOption } from '@libs/ui';

import type { SuggestionType } from './SuggestionTypeSelector.model';

export function getSelectedOptionForSuggestionType(
  allSuggestionTypes: AppSingleSelectOption<SuggestionType>[],
  suggestionType: SuggestionType
): AppSingleSelectOption<SuggestionType> | null {
  const result = allSuggestionTypes.find(
    (option) => option.id === suggestionType
  );

  return result || null;
}
